// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const H6OutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 640 512","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88v336c0 13.3 10.7 24 24 24s24-10.7 24-24V272h224v152c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-13.3-10.7-24-24-24s-24 10.7-24 24v136H48V88zm471-18.7a23.98 23.98 0 00-33.7 3.7l-98 122.5C364.4 224 352 259.5 352 296h.2c-.1 2.6-.2 5.3-.2 8 0 79.5 64.5 144 144 144s144-64.5 144-144-64.5-144-144-144c-6.8 0-13.4.5-20 1.4l46.7-58.4a23.9 23.9 0 00-3.8-33.7zM496 208a96 96 0 110 192 96 96 0 110-192z"}}]},"name":"h6","theme":"outlined"};

const H6Outlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={H6OutlinedSvg} />;
  H6Outlined.displayName = 'H6Outlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(H6Outlined);
